import React from "react";
import {FourPointStar, CrookedStar} from "../../../assets";

const HeroProduct1 = ({ onCTAClick }) => {
  return (
    <section className="st-surface-cream pt-6 sm:pt-8">
      <div className="relative w-full overflow-hidden bg-[--st-color-cream]">
        <div className="relative mx-auto max-w-7xl px-6 pb-16 pt-14 text-center sm:px-10 sm:pb-20 sm:pt-16 md:px-16 lg:pb-24">
          <img
            src={FourPointStar}
            alt=""
            className="pointer-events-none absolute left-[-28px] top-[6%] z-0 hidden w-[95px] md:block lg:left-[-16px] lg:w-[12rem]"
            loading="lazy"
          />
          <img
            src={CrookedStar}
            alt=""
            className="pointer-events-none absolute right-[-34px] top-[34%] z-0 hidden w-[130px] md:block lg:right-[-20px] lg:w-[14rem]"
            loading="lazy"
          />

          <h1 className="st-font-display relative z-10 text-[56px] leading-[0.98] text-[--st-color-heading] sm:text-[68px] md:text-[78px] lg:text-[84px]">
            <span className="block"><span className="text-[6rem] font-normal">Raih </span><span className="text-[6rem] font-normal italic">Skor</span><span className="text-[6rem] font-normal"> IELTS </span><span className="text-[6rem] font-semibold">7.0</span></span>
            <span className="block"><span className="font-normal">dengan</span> <span className="font-semibold">Garansi!</span></span>
          </h1>

          <p className="st-font-body mx-auto mt-7 max-w-[720px] text-[20px] leading-[1.6] text-[--st-color-text] sm:text-[22px] md:text-[24px] md:leading-[1.5]">
            Program private intensif untuk bantu kamu tembus skor target. Sudah membantu 2.000+ pejuang beasiswa!
          </p>

          <div className="mt-10 flex flex-col items-center justify-center gap-6 sm:flex-row sm:gap-12">
            <div className="flex items-center gap-6">
              <div className="text-center">
                <div className="text-[56px] font-bold text-[--st-color-red]">7.0</div>
                <div className="text-sm text-[--st-color-text-muted]">SKOR TARGET</div>
              </div>
              <div className="h-24 w-px bg-[--st-color-divider]" />
              <div className="text-center">
                <div className="text-[56px] font-bold text-[--st-color-red]">30</div>
                <div className="text-sm text-[--st-color-text-muted]">HARI BELAJAR</div>
              </div>
              <div className="h-24 w-px bg-[#e6d9c9]" />
              <div className="text-center">
                <div className="text-[56px] font-bold text-[--st-color-red]">2K+</div>
                <div className="text-sm text-[--st-color-text-muted]">ALUMNI</div>
              </div>
            </div>
          </div>

          <div className="mt-10">
            <button
              type="button"
              onClick={onCTAClick}
              className="mx-auto inline-block rounded-full bg-[--st-color-cta-yellow] px-12 py-3 text-[24px] font-bold text-[--st-color-red] shadow-[0_10px_20px_rgba(0,0,0,0.12)] hover:-translate-y-[1px] transition-transform duration-150">
              Daftar Sekarang
            </button>
          </div>
        </div>

        <div className="w-full overflow-hidden bg-[--st-color-program-red] py-2">
          <div className="st-font-body whitespace-nowrap text-center text-[26px] font-bold uppercase tracking-[0.02em] text-[--st-color-ticker-text] sm:text-[28px] md:text-[32px]">
            GIVE IT AND GO • GIVE IT AND GO • GIVE IT AND GO • GIVE IT AND GO • GIVE IT AND GO • GIVE IT AND GO •
          </div> 
        </div>
      </div>
    </section>
  );
};

export default HeroProduct1;
